import { get, put,Delete,post } from '../axios'

// 分组管理-列表
export const groupList = params => get(`/web/user/group/list`,params);

// 分组管理-新增
export const groupAdd = params => post(`/web/user/group/add`,params);

// 分组管理-删除
export const groupDelete = params => Delete('/web/user/group/delete/' + params.id, '');

// 分组管理-批量删除
export const groupDeletes = params => Delete('/web/user/group/deletes/' + params.id, '')

//分组管理-查看
export const groupView = params => get('/web/user/group/view/' + params.id, '');

// 分组管理-编辑
export const groupUpdate = params => put(`/web/user/group/update`,params);

//选择用户-列表（分组管理-网关管理通用）
export const selectList = params => get('/web/user/select/list', params);

//分组管理-成员列表
export const userList = params => get('/web/user/group/user/list', params);

//分组管理-网关列表
export const gatewayList = params => get('/web/user/group/gateway/list/' + params.id, '');

// 分组管理-成员列表-修改权限（创建者不可选择）
export const userUpdate = params => put(`/web/user/group/user/update`,params);

// 分组管理-成员列表-踢出分组（创建者不可选择）
export const groupUserDeletes = params => Delete('/web/user/group/user/delete/' + params, '')

// 分组管理-成员列表-添加成员
export const userAdd = params => put(`/web/user/group/add/userToGroup`,params);

//分组管理-重新生成二维码
export const groupRecreateCodeImage = params => post('/web/user/group/codeImage/recreate/' + params.id);
